import {Model} from 'MWC';
import {formatter} from 'MWComponents';
import {Validator} from '../../ExpressOrder/validator/validator.js';

const PHONE_NUMBER = 'contactPhoneNumber',
    formatsArr = {
        [PHONE_NUMBER]: '_phoneFormat'
    };

export default class extends Model {
    static fields;

    constructor(data) {
        super();
        this.fields = {
            contactPhoneNumber: {
                value: data.contactPhoneNumber,
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.phone]
            },
            passwordOTP: {
                value: data.passwordOTP,
                firstInput: true,
                isValid: true,
                errors: []
            }
        };

        this.canSubmit = false;
    }

    getField(fieldName) {
        return this.fields[fieldName];
    }

    run(data) {
        const name = data.name,
            value = formatsArr[name] ? this[formatsArr[name]](data.value) : data.value;

        this.fields[name].value = value;

        this.canSubmit = this.validate();
    }

    changeFirst(name) {
        this.fields[name].firstInput = false;
    }

    validate() {
        let result = true;
        // eslint-disable-next-line guard-for-in
        for (const item in this.fields) {
            Validator.validate(this.fields[item]);
            if (!this.fields[item].isValid) {
                result = false;
            }
        }

        return result;
    }

    _phoneFormat = value => {
        return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
    };
}
